import { IBalanceReport, IBalanceReportAmts } from "@pulse-ui/codegen/generated_ts/position_management";
import { getParties } from "../helpers";
import { capitalizeFirstChars } from "@pulse-ui/formatting";
import { IAGBalanceUpdateDataRow } from "../../../AlgoTable.types";
import { v4 as uuidv4 } from "uuid";

const amtToRow = (amt: IBalanceReportAmts) => {
    return {
        row_id: uuidv4(),
        asset: amt.asset,
        amt_total: amt?.amt_total?.toString() ?? "-",
    };
}

export const mapBalanceUpdate = (rpt: IBalanceReport): IAGBalanceUpdateDataRow => {
    const partiesGroup = rpt?.parties ? getParties(rpt.parties) : null;
    const amts = (rpt?.amts ?? []).map(amtToRow);
    return {
        detail_expander: "",
        row_id: uuidv4(),
        clearing_date: rpt?.clearing_date ?? "-",
        amts,
        pos_event_type: rpt?.pos_event_type?.toString() ? capitalizeFirstChars(rpt.pos_event_type.toString().split("_")) : "-",
        updated: rpt?.updated ?? "-",
        executing_firm: partiesGroup?.executing_firm?.party_id ?? "-",
        exchange: partiesGroup?.exchange?.party_id ?? "-",
        customer_account: partiesGroup?.customer_account?.party_id ?? "-",
        intermediary: partiesGroup?.intermediary?.party_id ?? "-",
        account_wallet: partiesGroup?.account_wallet?.party_id ?? "-",
        blockchain_wallet: partiesGroup?.blockchain_wallet?.party_id ?? "-",
    };
}